export default __webpack_public_path__ + "static/media/kitchen2-768w.b7f25626.png";